import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-weather-pest',
  templateUrl: './weather-pest.component.html',
  styleUrls: ['./weather-pest.component.scss']
})
export class WeatherPestComponent {


  @Input() mappedWeather: any[] = [];


  getTitle(period: string): string {
    const map: any = {
      last_24_hours: 'PEST.WEATHER_24',
      last_week: 'PEST.WEATHER_WEEK',
      last_two_weeks: 'PEST.WEATHER_2_WEEKS',
      next_24_hours: 'PEST.WEATHER_ESTIMATE_48H'
    };
    return map[period] || period;
  }

  getIcon(period: string): string {
    const icons: any = {
      last_24_hours: 'fas fa-clock',
      last_week: 'fas fa-calendar-week',
      last_two_weeks: 'fas fa-calendar-alt',
      next_24_hour: 'fas fa-calendar-alt'
    };
    return icons[period] || 'fas fa-question-circle';
  }

  getRainfallMin(period: string, data: any): string {
    if (period === 'last_two_weeks' || period === 'next_24_hour') {
      return data?.rainfall_week_2?.toFixed(2) || '-';
    }
    return '-';
  }

  getRainfallMax(period: string, data: any): string {
    return data?.total_rainfall_mm?.toFixed(2) || '-';
  }
  

}
